export * from './prime-events.model';
